import { Grid, List, ListItemButton, Typography } from "@mui/material";
import { getUserClaims } from "features/application/application-slice"
import { get_all_approvedMedia } from "features/approvedMedia/approvedMedia-slice";
import { fetch_all_approvedMedia, set_hidden_approvedMedia } from "features/auto-thunks"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { gridSpacing } from "store/constant";
import TitleService, { GetTimeSince } from "title-service";
import rq from 'components/RedQuick';
import SubCard from "ui-component/cards/SubCard";
import { setSelectedprocessedMedia } from "features/processedMedia/processedMedia-slice";
import { get_all_mediaList } from "features/mediaList/mediaList-slice";
import HideImageIcon from '@mui/icons-material/HideImage';
import ImageIcon from '@mui/icons-material/Image';

export default function ApprovedMediaComponent() {
    const claims = useSelector(getUserClaims);
    const [mediaFilter, setMediaFilter] = useState('');
    const all_approvedMedia = useSelector(get_all_approvedMedia);
    const dispatch = useDispatch();
    useEffect(() => {
        if (claims) {
            dispatch(fetch_all_approvedMedia({
                playerId: claims.player
            }));
        }
    }, [claims])
    return (
        <>
            <SubCard title={TitleService('Approved Media')}>
                <Grid container spacing={gridSpacing}>
                    <rq.RedQuickTextField title={TitleService('Filter')} value={mediaFilter || ''} onChange={(val) => {
                        setMediaFilter(val);
                    }} />
                    <Grid item xs={12} sx={{
                        maxHeight: 'calc(72vw)',
                        overflow: 'auto'
                    }}>
                        <List>
                            {(all_approvedMedia || []).filter((approvedMedia => {
                                if (mediaFilter) {
                                    let name = approvedMedia?.media?.name || approvedMedia?.media?.description;
                                    return `${name}`.toLowerCase().indexOf(`${mediaFilter}`.toLowerCase()) !== -1;
                                }
                                return true;
                            })).map((approvedMedia, index) => {
                                let name = approvedMedia?.media?.name || approvedMedia?.media?.description;
                                return (
                                    <ListItemButton key={index} >
                                        <Grid item xs={12}>
                                            <Grid container spacing={2}>
                                                <Grid item xs zeroMinWidth>
                                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                                        <div style={{
                                                            height: 60,
                                                            display: 'flex',
                                                            marginRight: 10,
                                                            borderRadius: '50%'
                                                        }}>
                                                            <img style={{
                                                            }} src={approvedMedia?.media?.thumbnail} />
                                                        </div>
                                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                            <Typography align="left" component="div" variant="subtitle1">
                                                                {name}
                                                            </Typography>
                                                            <Typography align="left" component="div" style={{
                                                                whiteSpace: 'nowrap',
                                                                maxWidth: 200,
                                                                textOverflow: 'ellipsis',
                                                                overflow: 'hidden'
                                                            }} variant="subtitle2">
                                                                {approvedMedia?.id}
                                                            </Typography>
                                                        </div>
                                                    </div>
                                                </Grid>
                                                <Grid item onClick={async () => {
                                                    await dispatch(set_hidden_approvedMedia({
                                                        hidden: !approvedMedia.hidden,
                                                        playerId: claims?.player,
                                                        approvedMediaId: approvedMedia.id
                                                    }))
                                                }}>
                                                    <Typography align="left" variant="caption">
                                                        {approvedMedia.hidden ? <HideImageIcon sx={{
                                                            fontSize: '1.875rem',
                                                            marginRight: 0.2,
                                                            verticalAlign: 'sub'
                                                        }} /> : <ImageIcon sx={{
                                                            fontSize: '1.875rem',
                                                            marginRight: 0.2,
                                                            verticalAlign: 'sub',
                                                            color: 'blue'
                                                        }} />}{GetTimeSince(approvedMedia.updated)}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </ListItemButton>
                                )
                            })}
                        </List>
                    </Grid>
                </Grid>

            </SubCard>
        </>
    )
}